export default {
  GOOGLE_MAPS: '3.49',
}
